/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import Grid from '../../../Grid';
import SingleSelect from '../../../common/Forms/SingleSelect';
import School from '../../../../models/School';
// import Dproject from '../../../../models/Dproject';
// import Student from '../../../../models/Student';
import InvoiceForm from './InvoiceForm';
// import Select from 'react-select';
// import Creatable from 'react-select/creatable';

const Mode = {
  create: 'create',
  edit: 'edit',
};

const handleButtonClick = (e, fn) => {
  e.preventDefault();
  fn();
};

const loadSchoolOptions = (value, callback, includeCustOnly = false) => {
  School.where({
    name: { match_distinct: value || 'SP_EMPTY' },
    sales_stat: includeCustOnly ? { match: 'CUST' } : {},
  })
    .all()
    .then((res) => {
      const schoolOptions = res.data.map((e) => ({
        label: e.cityName ? `${e.name} (${e.cityName})` : e.name,
        value: e.id,
      }));
      callback(schoolOptions);
    });
};

// Create contact options from school record fields
const createSchoolContactOptions = (school) => {
  const contactOptions = [];
  if (school) {
    // Principal
    if (school.prinFname || school.prinLname) {
      const name = `${school.prinFname || ''} ${school.prinLname || ''}`.trim();
      if (name) contactOptions.push({ label: `${name} (Principal)`, value: name });
    } else if (school.principal) {
      contactOptions.push({ label: `${school.principal} (Principal)`, value: school.principal });
    }

    // Vice Principal
    if (school.vpFname || school.vpLname) {
      const name = `${school.vpFname || ''} ${school.vpLname || ''}`.trim();
      if (name) contactOptions.push({ label: `${name} (Vice Principal)`, value: name });
    }

    // Secretary 1
    if (school.sec1Fname || school.sec1Lname) {
      const name = `${school.sec1Fname || ''} ${school.sec1Lname || ''}`.trim();
      if (name) contactOptions.push({ label: `${name} (Secretary)`, value: name });
    } else if (school.secretary) {
      contactOptions.push({ label: `${school.secretary} (Secretary)`, value: school.secretary });
    }

    // Secretary 2
    if (school.sec2Fname || school.sec2Lname) {
      const name = `${school.sec2Fname || ''} ${school.sec2Lname || ''}`.trim();
      if (name) contactOptions.push({ label: `${name} (Secretary 2)`, value: name });
    }

    // Yearbook Advisor
    if (school.ybFname || school.ybLname) {
      const name = `${school.ybFname || ''} ${school.ybLname || ''}`.trim();
      if (name) contactOptions.push({ label: `${name} (YB Advisor)`, value: name });
    }
  }
  return contactOptions;
};

// Create a map of contact names to their emails
const createContactEmailMap = (school) => {
  const emailMap = {};
  if (school) {
    // Principal
    if (school.prinFname || school.prinLname) {
      const name = `${school.prinFname || ''} ${school.prinLname || ''}`.trim();
      if (name && school.prinEmail) emailMap[name] = school.prinEmail;
    } else if (school.principal && school.prinEmail) {
      emailMap[school.principal] = school.prinEmail;
    }

    // Vice Principal
    if (school.vpFname || school.vpLname) {
      const name = `${school.vpFname || ''} ${school.vpLname || ''}`.trim();
      if (name && school.vpEmail) emailMap[name] = school.vpEmail;
    }

    // Secretary 1
    if (school.sec1Fname || school.sec1Lname) {
      const name = `${school.sec1Fname || ''} ${school.sec1Lname || ''}`.trim();
      if (name && school.sec1Email) emailMap[name] = school.sec1Email;
    } else if (school.secretary && school.sec1Email) {
      emailMap[school.secretary] = school.sec1Email;
    }

    // Secretary 2
    if (school.sec2Fname || school.sec2Lname) {
      const name = `${school.sec2Fname || ''} ${school.sec2Lname || ''}`.trim();
      if (name && school.sec2Email) emailMap[name] = school.sec2Email;
    }

    // Yearbook Advisor
    if (school.ybFname || school.ybLname) {
      const name = `${school.ybFname || ''} ${school.ybLname || ''}`.trim();
      if (name && school.ybEmail) emailMap[name] = school.ybEmail;
    }
  }
  return emailMap;
};


// const createContactEmailOptions = (school) => {
//   const contactOptions = [];
//   if (school) {
//     school.data.map((student) => contactOptions.push({ label: `${student}`, value: student }));
//   }

//   return contactOptions;
// };

// const createContactMap = (school) => {
//   const contactMap = {};

//   if (school.secretary) {
//     contactMap[school.secretary] = school.sec1Email;
//   }

//   if (school.principal) {
//     contactMap[school.principal] = school.prinEmail;
//   }

//   return contactMap;
// };

const defaultModel = {
  invoiceId: null,
  schoolId: { label: '', value: '' },
  requestedBy: { label: '', value: '' },
  contactEmail: { label: '', value: '' },
  itemType: { label: '', value: '' },
  dueDate: '',
  mustDeliverDate: '',
  assignedTo: { label: '', value: '' },
  assignedBy: { label: '', value: '' },
  deliveryMethod: 'Hand Deliver',
  dateOriginated: new Date(),
  lastUpdatedAt: new Date(),
  shippingInstructions: '',
  title: '',
  priority: '',
  psource: { label: '', value: '' },
  invoiceStatus: { label: '', value: '' },
  purchaseOrder: '',
  projectStatus: { label: '', value: '' },
  projectPath: '',
  invoiceSent: null,
  invoicePaid: false,
  invoiceDatePaid: null,
  invoiceAmountPaid: null,
};

const defaultSchoolInfoModel = {
  id: '',
  name: '',
  scode: '',
  route: '',
  principal: '',
  prin_email: '',
  secretary: '',
  sec1_email: '',
};

const DprojectForm = ({
  mode, project, productOptions, lineItems, urls, choicesMap, errors,
}) => {
  // Merge passed project with defaults to ensure all fields exist
  const initialModel = project ? { ...defaultModel, ...project } : defaultModel;
  const [model, setModel] = useState(initialModel);
  const [schoolInfo, setSchoolInfo] = useState(defaultSchoolInfoModel);
  const [contactMap, setContactMap] = useState({});
  const [contactEmailMap, setContactEmailMap] = useState({});
  const [invoiceItems, setInvoiceItems] = useState(lineItems);
  const [validationErrors, setValidationErrors] = useState([]);

  // Track if this is the initial mount to avoid clearing fields on edit mode load
  const isInitialMount = useRef(true);

  const options = choicesMap;

  // Client-side validation before form submit
  const validateForm = () => {
    const newErrors = [];
    if (!model.schoolId?.value) {
      newErrors.push('School must be selected');
    }
    if (!model.assignedTo?.value) {
      newErrors.push('Assigned To must be selected');
    }
    if (!model.invoiceStatus?.value || model.invoiceStatus.value.length < 2) {
      newErrors.push('Invoice Status (Inv Req) must be selected');
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    const formErrors = validateForm();
    if (formErrors.length > 0) {
      e.preventDefault();
      setValidationErrors(formErrors);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    return true;
  };

  // Handle Create Invoice - opens PDF in new tab
  const handleCreateInvoice = (e) => {
    // Check for line items first - show popup warning
    if (!invoiceItems || invoiceItems.length === 0) {
      e.preventDefault();
      alert('Cannot create invoice without line items.\n\nPlease add line items first, then click Update to save them.');
      return false;
    }

    const formErrors = validateForm();
    if (formErrors.length > 0) {
      e.preventDefault();
      setValidationErrors(formErrors);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
    // Set form to open in new tab
    const form = e.target.closest('form');
    if (form) {
      form.target = '_blank';
      // Reset target after a short delay so other submits work normally
      setTimeout(() => { form.target = ''; }, 100);
    }
    return true;
  };

  const setModelAttribute = (key, value) => {
    setModel((prevState) => ({
      ...prevState,
      [key]: value !== null ? value : { label: 'Select', value: '' },
    }));
  };

  useEffect(() => {
    if (model.schoolId.value) {
      // Only clear Requested By and Contact Email when user changes school (not on initial load)
      // This prevents clearing existing values when editing a project
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        setModelAttribute('requestedBy', { label: '', value: '' });
        setModelAttribute('contactEmail', { label: '', value: '' });
      }

      // Fetch school info and previous requested_by values in parallel
      Promise.all([
        School.find(model.schoolId.value),
        axios.get(`/api/v1/dprojects/previous_requested_by?school_id=${model.schoolId.value}`),
      ]).then(([schoolResp, previousResp]) => {
        setSchoolInfo(schoolResp.data);
        // Create email map for auto-populating contact email
        setContactEmailMap(createContactEmailMap(schoolResp.data));

        // Get school contacts
        const schoolContacts = createSchoolContactOptions(schoolResp.data);

        // Get previous requested_by values and convert to options
        const previousValues = (previousResp.data.data || [])
          .filter((val) => val && val.trim() !== '')
          .map((val) => ({ label: val, value: val }));

        // Merge: school contacts first, then previous values (excluding duplicates)
        const existingValues = new Set(schoolContacts.map((opt) => opt.value));
        const uniquePreviousValues = previousValues.filter((opt) => !existingValues.has(opt.value));

        setContactMap([...schoolContacts, ...uniquePreviousValues]);
      });
    }
  }, [model.schoolId]);

  useEffect(() => {
    if (model.requestedBy.value) {
      // First try to get email from school contacts map
      const emailFromSchool = contactEmailMap[model.requestedBy.value];
      if (emailFromSchool) {
        setModelAttribute('contactEmail', { label: emailFromSchool, value: emailFromSchool });
      } else if (model.schoolId.value) {
        // Fall back to API call for previous contact email
        axios.get(`/api/v1/dprojects/previous_contact_email?school_id=${model.schoolId.value}&requested_by=${model.requestedBy.value}`)
          .then((resp) => {
            if (resp.data.data[0]) {
              setModelAttribute('contactEmail', { label: resp.data.data[0], value: resp.data.data[0] });
            }
          });
      }
    }
  }, [model.requestedBy, contactEmailMap]);

  // Combine server errors with client validation errors
  const allErrors = [...(errors || []), ...validationErrors];

  // Create mode layout
  if (mode === Mode.create) {
    return (
      <>
        {/* Validation Errors Display */}
        {allErrors.length > 0 && (
          <div className="alert alert-danger" style={{ marginBottom: '16px' }}>
            <strong>Please fix the following errors:</strong>
            <ul style={{ marginBottom: 0, paddingLeft: '20px' }}>
              {allErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Row 1: School, District, City, Route, Secretary */}
        <Grid container xs={12} spacing={2}>
          <Grid item xs={12} lg={3}>
            <label htmlFor="dproject[school_id]">All Schools</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              name="dproject[school_id]"
              defaultValue={model.schoolId}
              loadOptions={(value, callback) => loadSchoolOptions(value, callback)}
              onChange={(val) => setModelAttribute('schoolId', val)}
              styles={{ control: (base) => ({ ...base, height: '38px', minHeight: '38px' }) }}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <label>District</label>
            <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.districtName || ''} readOnly />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>City</label>
            <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.cityName || ''} readOnly />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>Route</label>
            <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.route || ''} readOnly />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>Secretary</label>
            <input type="text" className="form-control" style={{ height: '38px' }} value={`${schoolInfo?.sec1Fname || ''} ${schoolInfo?.sec1Lname || ''}`.trim()} readOnly />
          </Grid>
        </Grid>

        {/* Row 2: Requested By, Contact Email, Item Type, Must Del Date, Sec Email */}
        <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
          <Grid item xs={12} lg={3}>
            <label htmlFor="dproject[requested_by]">Requested By</label>
            <input
              type="text"
              name="dproject[requested_by]"
              value={model.requestedBy && model.requestedBy.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={contactMap}
              selectedValue={model.requestedBy}
              placeholderText=""
              handleChange={(val) => setModelAttribute('requestedBy', val)}
              creatable
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <label htmlFor="dproject[contact_email]">Contact Email</label>
            <input
              type="text"
              name="dproject[contact_email]"
              value={model.contactEmail.value}
              onChange={(event) => setModelAttribute('contactEmail', { label: event.target.value, value: event.target.value })}
              className="form-control"
              style={{ height: '38px' }}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[project_type]">Item Type</label>
            <input type="text" name="dproject[project_type]" value={model.itemType.value} hidden readOnly />
            <SingleSelect
              options={options.itemType}
              selectedValue={model.itemType}
              placeholderText="Select item type"
              handleChange={(val) => setModelAttribute('itemType', val)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[must_date]">Must Del Date</label>
            <input
              type="date"
              className="form-control"
              style={{ height: '38px' }}
              name="dproject[must_date]"
              value={model.mustDeliverDate}
              onChange={(event) => setModelAttribute('mustDeliverDate', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>Sec Email</label>
            <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.sec1Email || ''} readOnly />
          </Grid>
        </Grid>

        {/* Row 3: Request (full width) */}
        <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
          <Grid item xs={12}>
            <label htmlFor="dproject[title]">Request</label>
            <input
              type="text"
              name="dproject[title]"
              className="form-control"
              style={{ height: '38px' }}
              value={model.title}
              onChange={(event) => setModelAttribute('title', event.target.value)}
            />
          </Grid>
        </Grid>

        {/* Row 4: Assigned to, Assigned by, Priority, Source, Inv Req, PO */}
        <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[assigned_to]">Assigned to</label>
            <input
              type="text"
              name="dproject[assigned_to]"
              value={model.assignedTo && model.assignedTo.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={options.assignedTo}
              selectedValue={model.assignedTo}
              placeholderText=""
              handleChange={(val) => setModelAttribute('assignedTo', val)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[assigned_by]">Assigned by</label>
            <input
              type="text"
              name="dproject[assigned_by]"
              value={model.assignedBy && model.assignedBy.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={options.assignedBy}
              selectedValue={model.assignedBy}
              placeholderText=""
              handleChange={(val) => setModelAttribute('assignedBy', val)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[priority]">Priority?</label>
            <div style={{ paddingTop: '8px' }}>
              <input
                type="checkbox"
                name="dproject[priority]"
                value={model.priority}
                checked={model.priority}
                onChange={(event) => setModelAttribute('priority', event.target.checked)}
              />
            </div>
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>Source</label>
            <input
              type="text"
              name="dproject[psource]"
              value={model.psource && model.psource.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={[
                { label: '', value: '' },
                { label: 'Catalog', value: 'Catalog' },
                { label: 'Email', value: 'Email' },
                { label: 'Phone', value: 'Phone' }
              ]}
              selectedValue={model.psource || { label: '', value: '' }}
              placeholderText=""
              handleChange={(val) => setModelAttribute('psource', val)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label>Inv Req</label>
            <input
              type="text"
              name="dproject[invoice_status]"
              value={model.invoiceStatus && model.invoiceStatus.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={options.invoiceStatus}
              selectedValue={model.invoiceStatus || options.invoiceStatus[0]}
              placeholderText=""
              handleChange={(val) => setModelAttribute('invoiceStatus', val)}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <label htmlFor="dproject[purchase_order]">PO #</label>
            <input
              type="text"
              name="dproject[purchase_order]"
              value={model.purchaseOrder || ''}
              className="form-control"
              style={{ height: '38px' }}
              onChange={(event) => setModelAttribute('purchaseOrder', event.target.value)}
            />
          </Grid>
        </Grid>

        {/* Row 5: Delivery method, Shipping Instructions */}
        <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
          <Grid item xs={12} lg={3}>
            <label htmlFor="dproject[delivery_type]">Delivery method</label>
            <input
              type="text"
              name="dproject[delivery_type]"
              value={model.deliveryMethod && model.deliveryMethod.value}
              hidden
              readOnly
            />
            <SingleSelect
              options={options.deliveryMethod}
              selectedValue={model.deliveryMethod}
              placeholderText="Select delivery method"
              handleChange={(val) => setModelAttribute('deliveryMethod', val)}
            />
          </Grid>
          <Grid item xs={12} lg={9}>
            <label htmlFor="dproject[shipping_instructions]">Shipping Instructions</label>
            <input
              type="text"
              name="dproject[shipping_instructions]"
              className="form-control"
              style={{ height: '38px' }}
              value={model.shippingInstructions}
              onChange={(event) => setModelAttribute('shippingInstructions', event.target.value)}
            />
          </Grid>
        </Grid>

        {/* Create button */}
        <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
          <Grid item xs={12}>
            <input type="text" name="dproject[status]" value={model.projectStatus && model.projectStatus.value} hidden readOnly />
            <input type="submit" className="btn btn-primary" name="stay" value="Create & Edit" onClick={handleSubmit} />
          </Grid>
        </Grid>
      </>
    );
  }

  // Edit mode layout
  return (
    <>
      {/* Row 1: School, District, City, Route, Secretary */}
      <Grid container xs={12} spacing={2}>
        <Grid item xs={12} lg={3}>
          <label htmlFor="dproject[school_id]">All Schools</label>
          <input
            type="text"
            className="form-control"
            style={{ height: '38px' }}
            value={model.schoolId.label}
            readOnly
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <label>District</label>
          <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.districtName || ''} readOnly />
        </Grid>
        <Grid item xs={12} lg={2}>
          <label>City</label>
          <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.cityName || ''} readOnly />
        </Grid>
        <Grid item xs={12} lg={2}>
          <label>Route</label>
          <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.route || ''} readOnly />
        </Grid>
        <Grid item xs={12} lg={2}>
          <label>Secretary</label>
          <input type="text" className="form-control" style={{ height: '38px' }} value={`${schoolInfo?.sec1Fname || ''} ${schoolInfo?.sec1Lname || ''}`.trim()} readOnly />
        </Grid>
      </Grid>

      {/* Row 2: Requested By, Contact Email, Item Type, Must Del Date, Sec Email */}
      <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
        <Grid item xs={12} lg={3}>
          <label htmlFor="dproject[requested_by]">Requested By</label>
          <input
            type="text"
            name="dproject[requested_by]"
            value={model.requestedBy && model.requestedBy.value}
            hidden
            readOnly
          />
          <SingleSelect
            options={contactMap}
            selectedValue={model.requestedBy}
            placeholderText=""
            handleChange={(val) => setModelAttribute('requestedBy', val)}
            creatable
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <label htmlFor="dproject[contact_email]">Contact Email</label>
          <div className="input-group" style={{ width: '100%' }}>
            <input
              type="text"
              name="dproject[contact_email]"
              value={model.contactEmail.value}
              onChange={(event) => setModelAttribute('contactEmail', { label: event.target.value, value: event.target.value })}
              className="form-control"
              style={{ height: '38px' }}
            />
            {model.contactEmail.value && (
              <span className="input-group-btn">
                <a
                  href={`/admin/schools/${model.schoolId.value}/email_drafts/new?email_to[]=${model.contactEmail.value}&recipient=custom_emails`}
                  className="btn btn-warning"
                  data-remote="true"
                  style={{ height: '38px' }}
                >
                  Email
                </a>
              </span>
            )}
          </div>
        </Grid>
        <Grid item xs={12} lg={2}>
          <label htmlFor="dproject[project_type]">Item Type</label>
          <input type="text" name="dproject[project_type]" value={model.itemType.value} hidden readOnly />
          <SingleSelect
            options={options.itemType}
            selectedValue={model.itemType}
            placeholderText="Select item type"
            handleChange={(val) => setModelAttribute('itemType', val)}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <label htmlFor="dproject[must_date]">Must Del Date</label>
          <input
            type="date"
            className="form-control"
            style={{ height: '38px' }}
            name="dproject[must_date]"
            value={model.mustDeliverDate}
            onChange={(event) => setModelAttribute('mustDeliverDate', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <label>Sec Email</label>
          <input type="text" className="form-control" style={{ height: '38px' }} value={schoolInfo?.sec1Email || ''} readOnly />
        </Grid>
      </Grid>

      {/* Row 3: Request (full width) */}
      <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
        <Grid item xs={12}>
          <label htmlFor="dproject[title]">Request</label>
          <input
            type="text"
            name="dproject[title]"
            className="form-control"
            style={{ height: '38px' }}
            value={model.title}
            onChange={(event) => setModelAttribute('title', event.target.value)}
          />
        </Grid>
      </Grid>

      {/* Row 4: Assigned to, Assigned by, Priority, Source, Inv Req, PO#, Paid, Date Paid, Amount PD */}
      <div className="row" style={{ marginTop: '16px' }}>
        <div className="col-lg-1 col-xs-6" style={{ paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>Assigned to</label>
          <input type="text" name="dproject[assigned_to]" value={model.assignedTo && model.assignedTo.value} hidden readOnly />
          <SingleSelect options={options.assignedTo} selectedValue={model.assignedTo} placeholderText="" handleChange={(val) => setModelAttribute('assignedTo', val)} />
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px', paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>Assigned by</label>
          <input type="text" name="dproject[assigned_by]" value={model.assignedBy && model.assignedBy.value} hidden readOnly />
          <SingleSelect options={options.assignedBy} selectedValue={model.assignedBy} placeholderText="" handleChange={(val) => setModelAttribute('assignedBy', val)} />
        </div>
        <div className="col-lg-1 col-xs-3" style={{ paddingLeft: '4px', paddingRight: '4px', maxWidth: '60px' }}>
          <label style={{ fontSize: '11px' }}>Priority?</label>
          <div style={{ paddingTop: '8px' }}>
            <input type="checkbox" name="dproject[priority]" value={model.priority} checked={model.priority} onChange={(event) => setModelAttribute('priority', event.target.checked)} />
          </div>
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px', paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>Source</label>
          <input type="text" name="dproject[psource]" value={model.psource && model.psource.value} hidden readOnly />
          <SingleSelect options={[ { label: '', value: '' }, { label: 'Catalog', value: 'Catalog' }, { label: 'Email', value: 'Email' }, { label: 'Phone', value: 'Phone' } ]} selectedValue={model.psource || { label: '', value: '' }} placeholderText="" handleChange={(val) => setModelAttribute('psource', val)} />
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px', paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>Inv Req</label>
          <input type="text" name="dproject[invoice_status]" value={model.invoiceStatus && model.invoiceStatus.value} hidden readOnly />
          <SingleSelect options={options.invoiceStatus} selectedValue={model.invoiceStatus} placeholderText="" handleChange={(val) => setModelAttribute('invoiceStatus', val)} />
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px', paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>PO #</label>
          <input type="text" name="dproject[purchase_order]" value={model.purchaseOrder || ''} className="form-control" style={{ height: '38px' }} onChange={(event) => setModelAttribute('purchaseOrder', event.target.value)} />
        </div>
        <div className="col-lg-1 col-xs-3" style={{ paddingLeft: '4px', paddingRight: '4px', maxWidth: '50px' }}>
          <label style={{ fontSize: '11px' }}>Paid</label>
          <div style={{ paddingTop: '8px' }}>
            <input type="checkbox" checked={model.invoicePaid || false} disabled style={{ cursor: 'default' }} />
          </div>
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px', paddingRight: '4px' }}>
          <label style={{ fontSize: '11px' }}>Date Paid</label>
          <input type="text" value={model.invoiceDatePaid || ''} className="form-control" style={{ height: '38px', fontSize: '12px' }} disabled />
        </div>
        <div className="col-lg-1 col-xs-6" style={{ paddingLeft: '4px' }}>
          <label style={{ fontSize: '11px' }}>Amount PD</label>
          <input type="text" value={model.invoiceAmountPaid ? `$${model.invoiceAmountPaid.toFixed(2)}` : ''} className="form-control" style={{ height: '38px', fontSize: '12px' }} disabled />
        </div>
      </div>

      {/* Row 5: Delivery method, Shipping Instructions */}
      <Grid container xs={12} spacing={2} style={{ marginTop: '16px' }}>
        <Grid item xs={12} lg={3}>
          <label htmlFor="dproject[delivery_type]">Delivery method</label>
          <input
            type="text"
            name="dproject[delivery_type]"
            value={model.deliveryMethod && model.deliveryMethod.value}
            hidden
            readOnly
          />
          <SingleSelect
            options={options.deliveryMethod}
            selectedValue={model.deliveryMethod}
            placeholderText="Select delivery method"
            handleChange={(val) => setModelAttribute('deliveryMethod', val)}
          />
        </Grid>
        <Grid item xs={12} lg={9}>
          <label htmlFor="dproject[shipping_instructions]">Shipping Instructions</label>
          <input
            type="text"
            name="dproject[shipping_instructions]"
            className="form-control"
            style={{ height: '38px' }}
            value={model.shippingInstructions}
            onChange={(event) => setModelAttribute('shippingInstructions', event.target.value)}
          />
        </Grid>
      </Grid>

      {/* Edit-specific fields below */}
      {true
            && (
            <>
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12}>
                  <label htmlFor="dproject[project_path]">Project Path</label>
                  <textarea
                    name="dproject[project_path]"
                    value={model.projectPath}
                    onChange={(event) => setModelAttribute('projectPath', event.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12}>
                  <div className="border" style={{ padding: '8px 16px' }}>
                    <InvoiceForm
                      invoiceId={model.invoiceId}
                      lineItems={invoiceItems}
                      productOptions={productOptions}
                      handleChange={setInvoiceItems}
                      invoiceSent={model.invoiceSent}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <label>Notes</label>
                  <textarea
                    name="dproject[description]"
                    placeholder="Enter request description"
                    style={{ height: '44px' }}
                    value={model.description}
                    onChange={(event) => setModelAttribute('description', event.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12}>
                  <label htmlFor="dproject[design_instructions]">Design Instructions</label>
                  <textarea
                    name="dproject[design_instructions]"
                    placeholder="Enter notes"
                    value={model.designInstructions}
                    onChange={(event) => setModelAttribute('designInstructions', event.target.value)}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <label htmlFor="dproject[status]">Status</label>
                  <input
                    type="text"
                    name="dproject[status]"
                    value={model.projectStatus && model.projectStatus.value}
                    hidden
                    readOnly
                  />
                  <select
                    className="form-control"
                    style={{ height: '52px' }}
                    value={model.projectStatus?.value || ''}
                    onChange={(e) => {
                      const selected = options.projectStatus.find((opt) => opt.value === e.target.value);
                      setModelAttribute('projectStatus', selected || { label: '', value: '' });
                    }}
                  >
                    <option value="">Select project status</option>
                    {options.projectStatus && options.projectStatus.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <label htmlFor="dproject[project_changes]">Changes</label>
                  <textarea
                    name="dproject[project_changes]"
                    style={{ height: '52px' }}
                    value={model.projectChanges}
                    onChange={(event) => setModelAttribute('projectChanges', event.target.value)}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <label>Change Log</label>
                  <textarea style={{ height: '52px' }} value={model.changeLog} readOnly />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <label htmlFor="dproject[printing_instructions]">Printing Instructions</label>
                  <textarea
                    name="dproject[printing_instructions]"
                    style={{ height: '52px' }}
                    value={model.printingInstructions}
                    onChange={(event) => setModelAttribute('printingInstructions', event.target.value)}
                  />
                </Grid>
              </Grid>
              {/* Row 1: Action buttons */}
              <div style={{ display: 'flex', gap: '8px', marginTop: '16px', width: '100%', paddingRight: '15px' }}>
                <div style={{ flex: 1 }}>
                  <input type="submit" name="commit" value="Update" className="btn btn-primary btn-block" style={{ width: '100%' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <a
                    href={urls && urls.duplicateUrl}
                    className="btn btn-warning btn-block"
                    data-method="post"
                    data-confirm="Create a duplicate of this project?"
                    style={{ width: '100%', display: 'block', textAlign: 'center' }}
                  >
                    Duplicate
                  </a>
                </div>
                <div style={{ flex: 1 }}>
                  <button
                    type="button"
                    className="btn btn-info btn-block"
                    onClick={(e) => handleButtonClick(e, () => window.print())}
                    style={{ width: '100%' }}
                  >
                    Print
                  </button>
                </div>
                <div style={{ flex: 1 }}>
                  <button
                    type="button"
                    className="btn btn-success btn-block"
                    style={{ width: '100%' }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!window.confirm('Mark this project as Delivered?')) return;
                      fetch(`/api/v1/dprojects/${model.id}/mark_as_delivered`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
                        },
                      })
                        .then((res) => res.json())
                        .then((data) => {
                          if (data.success) {
                            window.alert(`Project marked as Delivered on ${data.delivery_date}`);
                            setModelAttribute('status', 'Delivered');
                          }
                        })
                        .catch(() => window.alert('Error marking as delivered'));
                    }}
                  >
                    Mark Delivered
                  </button>
                </div>
                <div style={{ flex: 1 }}>
                  <a href={urls && urls.shippingUrl} className="btn btn-primary btn-block" style={{ width: '100%', display: 'block', textAlign: 'center' }}>Ship UPS</a>
                </div>
                <div style={{ flex: 1 }}>
                  {model.invoiceId === null ? (
                    <input
                      type="submit"
                      name="commit"
                      value="Create Invoice"
                      className="btn btn-info btn-block"
                      style={{ width: '100%' }}
                      onClick={handleCreateInvoice}
                    />
                  ) : (
                    <a href={urls && urls.showInvoiceUrl} target="_blank" rel="noopener noreferrer" className="btn btn-info btn-block" style={{ width: '100%', display: 'block', textAlign: 'center' }}>View Invoice</a>
                  )}
                </div>
                {model.invoiceId !== null && (
                <div style={{ flex: 1 }}>
                  <a href={urls && urls.editInvoiceUrl} className="btn btn-warning btn-block" style={{ width: '100%', display: 'block', textAlign: 'center' }}>Edit Invoice</a>
                </div>
                )}
                <div style={{ flex: 1 }}>
                  <a
                    href={urls && urls.deleteUrl}
                    className="btn btn-danger btn-block"
                    data-method="delete"
                    data-confirm="Are you sure you want to delete this project?"
                    style={{ width: '100%', display: 'block', textAlign: 'center' }}
                  >
                    Delete
                  </a>
                </div>
              </div>
              {/* Row 2: PDF/JPG buttons */}
              {urls && (urls.templatePdfs?.length > 0 || urls.templateJpgs?.length > 0 || urls.spiritWeekPosterUrl) && (
              <div style={{ display: 'flex', gap: '8px', marginTop: '8px', width: '100%', paddingRight: '15px' }}>
                {urls.templatePdfs && urls.templatePdfs.length === 1 && (
                  <div>
                    <a
                      href={urls.templatePdfs[0].url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success"
                      style={{ display: 'block', textAlign: 'center' }}
                    >
                      Show PDF
                    </a>
                  </div>
                )}
                {urls.templatePdfs && urls.templatePdfs.length > 1 && (
                  <div style={{ position: 'relative' }} className="dropdown">
                    <button
                      className="btn btn-success dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      Show PDF <span className="caret" />
                    </button>
                    <ul className="dropdown-menu">
                      {urls.templatePdfs.map((pdf, idx) => (
                        <li key={idx}>
                          <a href={pdf.url} target="_blank" rel="noopener noreferrer">
                            {pdf.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {urls.templateJpgs && urls.templateJpgs.length === 1 && (
                  <div>
                    <a
                      href={urls.templateJpgs[0].url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-info"
                      style={{ display: 'block', textAlign: 'center' }}
                    >
                      5x7 JPG
                    </a>
                  </div>
                )}
                {urls.templateJpgs && urls.templateJpgs.length > 1 && (
                  <div style={{ position: 'relative' }} className="dropdown">
                    <button
                      className="btn btn-info dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      5x7 JPG <span className="caret" />
                    </button>
                    <ul className="dropdown-menu">
                      {urls.templateJpgs.map((jpg, idx) => (
                        <li key={idx}>
                          <a href={jpg.url} target="_blank" rel="noopener noreferrer">
                            {jpg.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {urls.spiritWeekPosterUrl && (
                  <div>
                    <a
                      href={urls.spiritWeekPosterUrl}
                      className="btn btn-success"
                      style={{ display: 'block', textAlign: 'center' }}
                    >
                      Spirit Week PDF
                    </a>
                  </div>
                )}
              </div>
              )}
            </>
            )}
    </>
  );
};

DprojectForm.propTypes = {
  mode: PropTypes.oneOf([Mode.create, Mode.edit]),
  // eslint-disable-next-line react/forbid-prop-types
  project: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  lineItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  productOptions: PropTypes.array,
  urls: PropTypes.shape({
    createInvoiceUrl: PropTypes.string,
    showInvoiceUrl: PropTypes.string,
    editInvoiceUrl: PropTypes.string,
    shippingUrl: PropTypes.string,
    spiritWeekPosterUrl: PropTypes.string,
    templatePdfs: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string, label: PropTypes.string })),
  }),
  // eslint-disable-next-line react/forbid-prop-types
  choicesMap: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.array,
};

DprojectForm.defaultProps = {
  mode: Mode.create,
  project: null,
  lineItems: [],
  productOptions: [],
  urls: {},
  choicesMap: {},
  errors: [],
};

export default DprojectForm;
